import * as React from "react";

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={426} height={366} {...props}>
    <g clipPath="url(#a)">
      <path fill="#fff" d="M0 0h741v424H0z" />
      <g fill="currentColor">
        <path d="M167.941-459.322 28.622-79.368S-1.363-.492 88.334 72.593 228.932-.873 325.233 42.3c162.065 79.451-85.006 219.865-.612 304.929S727.756 2.64 727.756 2.64Z" />
        <path
          d="M586.232 0S435.143 40.858 315.289 133.037 91.835 253.37 106.816 368.717 227.782 368.07 275.7 466.9C350.2 638.043.605 426.309 0 546.385s674.479 177.647 674.479 177.647Z"
          transform="rotate(-45 -147.457 101.697)"
          style={{
            mixBlendMode: "overlay",
            isolation: "isolate",
          }}
        />
      </g>
    </g>
  </svg>
);

export default SvgComponent;
